const isStandalone = process.env.REACT_APP_TYPE === 'standalone';

export const ROUTE_PREFIX = isStandalone ? '' : '/report';

export function appRoute(path: string, isRoute?: boolean): string {
  if (isStandalone && path === '/payment' && !isRoute) {
    return '/subscriptions';
  }
  return `${ROUTE_PREFIX}${path}`;
}
